import { Component, Input } from '@angular/core'

@Component({
  selector: 'mb-myaccount-nav-bubble',
  templateUrl: './mb-myaccount-nav-bubble.component.html',
  styleUrls: ['./mb-myaccount-nav-bubble.component.scss']
})
export class MbMyaccountNavBubbleComponent {

  @Input() isExternalLink = false
  @Input() linkText = ''
  @Input() linkUrl = ''
  @Input() icon = ''
}
